


























































import axios from 'axios'
import { Component } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import {
  apiV1JobPath,
  apiV1RecruitPath,
  apiV1RecruitsApplicantPath,
  apiV1RecruitsFavoritePath,
  apiV1UsersCurrentPath,
  apiV1UsersPath
} from '@/rails/routes'
import { IRecruit } from '@/models/Recruit'
import User, { IUser } from '@/models/User'
import ChangeJobForm from '@/components/entry/ChangeJobForm.vue'
import Global from '@/Global.vue'
import FormBase from '@/pages/form-base'
import {IJob} from "@/models/Job"

@Component({
  components: {
    Global,
    ChangeJobForm
  }
})
export default class RecruitsIndex extends VueBase {
  user: User = null
  recruitId: number = 0
  showedConfirm = false
  favorited = false
  errors = {}

  get alreadyApply(): boolean {
    if (!this.user) {
      return false
    }
    return this.user.applicants.some(a => a.recruit_id === this.recruitId)
  }

  async mounted(): Promise<void> {
    this.loading = true
    const paths = window.location.pathname.split('/')
    const path = paths[1]
    const id = paths[2]
    if (path === 'recruit') {
      const recruit = await axios.get<IRecruit>(apiV1RecruitPath(id))
      this.recruitId = recruit.data.id
    } else if (path === 'jobs') {
      const job = await axios.get<IJob>(apiV1JobPath(id))
      this.recruitId = job.data.recruit_id
    }
    await this.reloadUser()
    this.loading = false
  }

  async reloadUser(): Promise<void> {
    try {
      const res = await axios.get<IUser>(apiV1UsersCurrentPath())
      if (res.data) {
        this.user = new User(res.data)
        this.favorited = this.user.favorite_recruits.some(f => f.recruit_id === this.recruitId)
      }
    } catch (e) {
      console.log(e)
    }
  }

  async entry(): Promise<void> {
    if (!(this.$refs.changeJobForm as FormBase).validate()) {
      this.showError('入力内容に不備があります。確認してください。')
      return
    }

    try {
      await axios.put(apiV1UsersPath(), {
        user: this.user.toParams()
      })
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
      this.errors = JSON.parse(e.request.response)
      throw e
    }

    try {
      await axios.post(apiV1RecruitsApplicantPath(this.recruitId))
      this.showMessage('応募が完了しました、コーディネーターからのご連絡をお待ちください。')
      this.showedConfirm = false
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
      this.errors = JSON.parse(e.request.response)
      throw e
    }
  }

  onEntry(): void {
    if (this.user) {
      this.showedConfirm = true
    } else {
      this.redirectToSignUp('会員登録、またはログインしてください')
    }
  }

  async onFavorite(): Promise<void> {
    if (!this.user) {
      this.redirectToSignUp('会員登録、またはログインしてください')
      return
    }

    try {
      await axios.put(apiV1RecruitsFavoritePath(this.recruitId), {
        favorite: !this.favorited
      })
      this.favorited = !this.favorited
    } catch (e) {
      this.showError('入力内容に不備があります。確認してください。')
      this.errors = JSON.parse(e.request.response)
      throw e
    }
  }
}
